import { render, staticRenderFns } from "./CheckoutPage.vue?vue&type=template&id=0b2ffa3a"
import script from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports